import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { OptionProps } from 'react-select-modern';
import { components } from 'react-select-modern';

import { EMouseLeaveDelay, Tooltip } from '@feathr/components';
import type { IObjectiveOptionWithIcon } from '@feathr/extender/hooks';

import * as styles from './ObjectiveOption.css';

function ObjectiveOption(props: Readonly<OptionProps<IObjectiveOptionWithIcon>>): JSX.Element {
  const { data } = props;
  const { t } = useTranslation();

  const option = (
    <components.Option {...props}>
      <div className={styles.root}>
        <div>{data.icon}</div>
        <div>
          <span className={styles.label}>{data.name}</span>
          <p className={styles.description}>{data.description}</p>
        </div>
      </div>
    </components.Option>
  );

  return data.isDisabled ? (
    <Tooltip
      className={styles.tooltipWrapper}
      closeDelay={EMouseLeaveDelay.Link}
      position={'bottom-start'}
      title={t('This objective is not available for the selected campaign type')}
    >
      {option}
    </Tooltip>
  ) : (
    option
  );
}

export default ObjectiveOption;
